import { get } from 'lodash';
import React from 'react';
import { ANTRAG_TYP, ANTRAGS_FORMULAREN, ART_DES_ANTRAGS } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import { checkIfAntragstellendeHasComment } from '../../../application-helper-function/PruefAssistenzHelperFunktion';
import AnsprechpartnerGlobal, { getFormStrucAnsprechpartnerGlobal } from './content/AnsprechpartnerGlobal';
import AntragstellerGlobal, { getFormStrucAntragstellerGlobal } from './content/AntragstellerGlobal';
import AntragstelerinGlobal, { getFormStrucAntragstelerinGlobal } from './content/AntragstellerinGlobal';
import BankVerbindungGlobal, { getFormStrucBankVerbindungGlobal } from './content/BankVerbindungGlobal';
import AntragstellerSkizzeLoewe, { getFormStrucAntragstellerSkizzeLoewe } from './content/loewe/AntragstellerSkizzeLoewe';
import StammdatenblattGlobal, { getFormStrucStammdatenblattGlobal } from './content/StammdatenBlatt';

// import Schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

export const TreeStructureAntragstellerGlobal = (application: any, readOnly: boolean) => {
	const hasComment = checkIfAntragstellendeHasComment(readOnly, application);
	const antragsformular = get(application, P.Allgemein_Antragsformular.path);
	const isLoewe = antragsformular === ANTRAGS_FORMULAREN.Loewe;
	const isFormantrag = get(application, P.Allgemein_Art_Des_Antrags.path, '') === ART_DES_ANTRAGS.Formantrag;
	const currentIban = get(application, P.Antragstellende_Organisation_Bankverbindung_IBAN.path, '');
	const skizzeIban = get(application, P.Skizze.schema.attributes.Antragstellende_Organisation_Bankverbindung_IBAN.path, '');
	const urspruenglicherAntragIban = get(
		application,
		P.urspruenglicher_Antrag.schema.attributes.Antragstellende_Organisation_Bankverbindung_IBAN.path,
		'',
	);
	const hasSkizzeIban = Boolean(skizzeIban);
	const hasUrspruenglicherAntragIban = Boolean(urspruenglicherAntragIban);
	const isSameIbanAsUrspruenglicherAntrag = currentIban === urspruenglicherAntragIban;
	const hideLoeweStammdatenblatt =
		isLoewe &&
		((hasSkizzeIban && currentIban === skizzeIban) || (isFormantrag && hasUrspruenglicherAntragIban && isSameIbanAsUrspruenglicherAntrag));

	let treeNodes: TreeNodeType[] = [
		{
			label: 'Antragstellende',
			content: <AntragstelerinGlobal hasComment={hasComment} />,
			formStruc: getFormStrucAntragstelerinGlobal(application),
			hasComment: hasComment,
			children: [
				...getAntragstellerGlobalTreeStructure(application, hasComment),
				{
					label: 'II. Ansprechpartner',
					content: <AnsprechpartnerGlobal hasComment={hasComment} />,
					formStruc: getFormStrucAnsprechpartnerGlobal(application),
				},
				...((
					get(application, P.Allgemein_Typ.path) === ANTRAG_TYP.Antrag ||
					(get(application, P.Allgemein_Typ.path) === ANTRAG_TYP.Skizze &&
						get(application, P.Allgemein_Antragsformular.path) === ANTRAGS_FORMULAREN.Loewe)
				) ?
					[
						{
							label: 'III. Bankverbindung',
							content: <BankVerbindungGlobal hasComment={hasComment} />,
							formStruc: getFormStrucBankVerbindungGlobal(application),
						},
						...(!hideLoeweStammdatenblatt ?
							[
								{
									label: 'IV. Stammdatenblatt',
									content: <StammdatenblattGlobal hasComment={hasComment} />,
									formStruc: getFormStrucStammdatenblattGlobal(),
								},
							]
						:	[]),
					]
				:	[
						{
							label: 'III. Stammdatenblatt',
							content: <StammdatenblattGlobal hasComment={hasComment} />,
							formStruc: getFormStrucStammdatenblattGlobal(),
						},
					]),
			],
		},
	];
	return treeNodes;
};

const getAntragstellerGlobalTreeStructure = (application: any, hasComment?: boolean) => {
	const antragsformular = get(application, P.Allgemein_Antragsformular.path);

	if (antragsformular === ANTRAGS_FORMULAREN.Loewe) {
		return [
			{
				label: 'I. Organisation',
				content: <AntragstellerSkizzeLoewe hasComment={hasComment} />,
				formStruc: getFormStrucAntragstellerSkizzeLoewe(application),
			},
		];
	} else {
		return [
			{
				label: 'I. Organisation',
				content: <AntragstellerGlobal hasComment={hasComment} />,
				formStruc: getFormStrucAntragstellerGlobal(application),
			},
		];
	}
};
